import * as React from "react";
import { FC, useRef } from "react";
import { Feature } from "ol";
import { Layer } from "ol/layer";
import { useMiniMap } from "./useMiniMap";
import { MiniMapButton } from "./miniMapButton";

export type OnMiniFeatureClickCallback = ({ layerId, objectId }: { layerId: string; objectId: string }) => void;

export interface IMiniMap {
    /**
     * (Required) All of the features, with custom data fields added, such as "VISITED", "LIKE" etc
     */
    allFeatures: Feature[] | null;
    /**
     * array of layers, containing predefined Route data
     */
    routeLayers: Layer[];
    /**
     * callback on object click, returns identified object, as { layerId: string; objectId: string }
     */
    onClickOnMiniFeature: OnMiniFeatureClickCallback;
    /**
     * callback, to select Route, pass ROUTEID field value as argument
     */
    onSelectRoute: (routeId: string) => void;
    /**
     * string, representing Route ID
     */
    routeId: string;
}

export const MiniMap: FC<IMiniMap> = (props: IMiniMap) => {
    const ref = useRef<HTMLDivElement>();
    const map = useMiniMap(ref, props);

    return (
        <div ref={ref} style={{ width: "100%", height: "100%", display: "block", position: "relative" }}>
            <MiniMapButton onClick={props.onSelectRoute} id={props.routeId} />
        </div>
    );
};
